﻿import React from "react";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/system";
import PropTypes from "prop-types";

const tabsStyles = {
  primary: {
    boxSizing: "border-box",
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  secondary: {
    boxSizing: "border-box",
    borderBottom: "1.5px solid var(--grey-lowlight)",
    "& .MuiTabs-indicator": {
      height: "2px",
      backgroundColor: "var(--primary-main)",
    },
  },
  tertiary: {
    boxSizing: "border-box",
    borderBottom: "1.5px solid var(--grey-lowlight)",
    "& .MuiTabs-indicator": {
      height: "2px",
      backgroundColor: "var(--primary-main)",
    },
  },
  viewData: {
    boxSizing: "border-box",
    "& .MuiTabs-indicator": {
      height: "2px",
      backgroundColor: "var(--primary-main)",
    },
  },
  gridSelector: {
    boxSizing: "border-box",
    border: "1.5px solid var(--grey-lowlight)",
    borderRadius: "12px 12px 0 0",
    backgroundColor: "var(--default-light)",
    "& .MuiTabs-indicator": {
      height: "2px",
      backgroundColor: "var(--primary-main)",
    },
    "& .MuiTab-root.Mui-selected": {
      backgroundColor: "transparent",
    },
  },
};

const getTabsStyles = (variant) => {
  return tabsStyles[variant];
};

const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant }) => {
  const styles = getTabsStyles(variant);
  return {
    ...styles,
  };
});

const ShepTabs = ({ variant = "primary", ...props }) => {
  return (
    <StyledTabs
      variant={variant}
      TabIndicatorProps={
        variant === "viewData"
          ? { style: { backgroundColor: "var(--primary-main)" } }
          : {}
      }
      {...props}
    />
  );
};

ShepTabs.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "viewData",
    "gridSelector",
  ]),
};

export default ShepTabs;
